// Bilingual dictionary. Each key -> {en, hi}
export const dict = {
  club_name: { en: "Lions Club Jaipur Hawamahal", hi: "लायंस क्लब जयपुर हवामहल" },
  nav_home: { en: "Home", hi: "मुख्य पृष्ठ" },
  nav_about: { en: "About", hi: "परिचय" },
  nav_process: { en: "Process", hi: "प्रक्रिया" },
  nav_eligibility: { en: "Eligibility", hi: "पात्रता" },
  nav_contact: { en: "Contact", hi: "संपर्क" },
  nav_dashboard: { en: "My Application", hi: "मेरा आवेदन" },
  nav_admin: { en: "Admin", hi: "प्रशासन" },
  login: { en: "Login", hi: "लॉगिन" },
  register: { en: "Register", hi: "पंजीकरण" },
  logout: { en: "Logout", hi: "लॉगआउट" },
  apply_now: { en: "Apply for Registration", hi: "पंजीकरण के लिए आवेदन करें" },
  event_on: { en: "10 March 2027", hi: "10 मार्च 2027" },

  // landing sections
  process_title: { en: "How the registration works", hi: "पंजीकरण कैसे काम करता है" },
  process_1_t: { en: "Create an account", hi: "खाता बनाएँ" },
  process_1_d: { en: "Register with your email to start and securely resume your application anytime.", hi: "अपने ईमेल से पंजीकरण करें और अपना आवेदन कभी भी सुरक्षित रूप से जारी रखें।" },
  process_2_t: { en: "Fill the application", hi: "आवेदन भरें" },
  process_2_d: { en: "Provide groom, bride, parents' consent and document details across guided steps.", hi: "निर्देशित चरणों में वर, वधू, माता-पिता की सहमति और दस्तावेज़ विवरण दें।" },
  process_3_t: { en: "Review & verification", hi: "समीक्षा एवं सत्यापन" },
  process_3_d: { en: "Organisers review your documents and update your status. You are notified at each step.", hi: "आयोजक आपके दस्तावेज़ों की समीक्षा करते हैं और स्थिति अपडेट करते हैं। हर चरण पर आपको सूचित किया जाता है।" },

  eligibility_title: { en: "Eligibility", hi: "पात्रता" },
  about_title: { en: "About the event", hi: "कार्यक्रम के बारे में" },
  privacy_title: { en: "Privacy notice", hi: "गोपनीयता सूचना" },
  privacy_body: {
    en: "Your personal details and documents are collected only to organise and verify participation in 101 Kanya Vivah. We store documents privately with restricted access. We will NOT publish applicants' names, photos, documents or verification status publicly without your separate, explicit consent. You may request correction or withdrawal at any time.",
    hi: "आपकी व्यक्तिगत जानकारी और दस्तावेज़ केवल 101 कन्या विवाह में भागीदारी के आयोजन एवं सत्यापन हेतु एकत्र किए जाते हैं। दस्तावेज़ प्रतिबंधित पहुँच के साथ निजी रूप से संग्रहीत होते हैं। हम आपकी अलग, स्पष्ट सहमति के बिना आवेदकों के नाम, फ़ोटो, दस्तावेज़ या सत्यापन स्थिति सार्वजनिक रूप से प्रकाशित नहीं करेंगे। आप किसी भी समय सुधार या वापसी का अनुरोध कर सकते हैं।",
  },
  contact_title: { en: "Contact the organisers", hi: "आयोजकों से संपर्क करें" },
  venue: { en: "Venue", hi: "स्थान" },
  date: { en: "Date", hi: "तिथि" },

  // auth
  email: { en: "Email", hi: "ईमेल" },
  password: { en: "Password", hi: "पासवर्ड" },
  full_name: { en: "Full name", hi: "पूरा नाम" },
  phone: { en: "Phone", hi: "फ़ोन" },
  forgot_password: { en: "Forgot password?", hi: "पासवर्ड भूल गए?" },
  no_account: { en: "Don't have an account?", hi: "खाता नहीं है?" },
  have_account: { en: "Already have an account?", hi: "पहले से खाता है?" },
  reset_password: { en: "Reset password", hi: "पासवर्ड रीसेट करें" },
  send_reset: { en: "Send reset link", hi: "रीसेट लिंक भेजें" },
  new_password: { en: "New password", hi: "नया पासवर्ड" },

  // wizard
  wizard_title: { en: "Registration Application", hi: "पंजीकरण आवेदन" },
  step_groom: { en: "Groom details", hi: "वर विवरण" },
  step_bride: { en: "Bride details", hi: "वधू विवरण" },
  step_consent: { en: "Parents' consent", hi: "माता-पिता की सहमति" },
  step_docs: { en: "Documents", hi: "दस्तावेज़" },
  step_review: { en: "Review & submit", hi: "समीक्षा एवं जमा करें" },
  save_continue: { en: "Save & continue", hi: "सहेजें और जारी रखें" },
  back: { en: "Back", hi: "पीछे" },
  save_draft: { en: "Save draft", hi: "प्रारूप सहेजें" },
  submit_application: { en: "Submit application", hi: "आवेदन जमा करें" },
  dob: { en: "Date of birth", hi: "जन्म तिथि" },
  age_on_event: { en: "Age on 10 Mar 2027", hi: "10 मार्च 2027 को आयु" },
  address: { en: "Address", hi: "पता" },
  parent_guardian: { en: "Parent / Guardian name", hi: "माता-पिता / अभिभावक का नाम" },
  years: { en: "years", hi: "वर्ष" },

  saved: { en: "Progress saved", hi: "प्रगति सहेजी गई" },
  submitted_ok: { en: "Application submitted successfully", hi: "आवेदन सफलतापूर्वक जमा किया गया" },

  // dashboard
  my_status: { en: "Application status", hi: "आवेदन स्थिति" },
  continue_app: { en: "Continue application", hi: "आवेदन जारी रखें" },
  start_app: { en: "Start application", hi: "आवेदन शुरू करें" },
  view_app: { en: "View application", hi: "आवेदन देखें" },
  organiser_notes: { en: "Notes from organisers", hi: "आयोजकों से टिप्पणियाँ" },
  timeline: { en: "Timeline", hi: "समयरेखा" },

  // admin
  admin_queue: { en: "Application review queue", hi: "आवेदन समीक्षा सूची" },
  filter_status: { en: "Filter by status", hi: "स्थिति अनुसार छाँटें" },
  applicant: { en: "Applicant", hi: "आवेदक" },
  status: { en: "Status", hi: "स्थिति" },
  actions: { en: "Actions", hi: "कार्रवाई" },
  review: { en: "Review", hi: "समीक्षा" },
  approve_verify: { en: "Verify", hi: "सत्यापित करें" },
  decline: { en: "Decline", hi: "अस्वीकार" },
  waitlist: { en: "Waitlist", hi: "प्रतीक्षा सूची" },
  more_info: { en: "Request more info", hi: "अधिक जानकारी माँगें" },
  under_review: { en: "Mark under review", hi: "समीक्षाधीन करें" },
  add_note: { en: "Add review note", hi: "समीक्षा टिप्पणी जोड़ें" },
  reason: { en: "Reason / note", hi: "कारण / टिप्पणी" },
  documents: { en: "Documents", hi: "दस्तावेज़" },
  event_settings: { en: "Event settings", hi: "कार्यक्रम सेटिंग्स" },
  settings: { en: "Settings", hi: "सेटिंग्स" },
  save: { en: "Save", hi: "सहेजें" },

  // features
  email_login: { en: "Email", hi: "ईमेल" },
  otp_login: { en: "Mobile OTP", hi: "मोबाइल OTP" },
  mobile_number: { en: "Mobile number", hi: "मोबाइल नंबर" },
  send_otp: { en: "Send OTP", hi: "OTP भेजें" },
  enter_otp: { en: "Enter OTP", hi: "OTP दर्ज करें" },
  verify_otp: { en: "Verify & sign in", hi: "सत्यापित करें और लॉगिन करें" },
  honour_gallery: { en: "Honour Gallery", hi: "सम्मान सूची" },
  gallery_desc: { en: "Couples who have completed verification and chosen to be featured. Shown only with their consent.", hi: "जिन जोड़ों का सत्यापन पूर्ण हो गया है और जिन्होंने प्रदर्शित होने की सहमति दी है। केवल उनकी सहमति से दिखाया गया है।" },
  gallery_empty: { en: "No couples have opted to be featured yet.", hi: "अभी तक किसी जोड़े ने प्रदर्शित होने का विकल्प नहीं चुना है।" },
  export_csv: { en: "Export verified (CSV)", hi: "सत्यापित निर्यात (CSV)" },
  publish_consent_title: { en: "Feature us in the Honour Gallery", hi: "हमें सम्मान सूची में दिखाएँ" },
  publish_consent_desc: { en: "Optional. If you turn this on, your couple appears on the public Honour Gallery. Your documents, contact details and full information are never shown.", hi: "वैकल्पिक। यदि आप इसे चालू करते हैं, तो आपका जोड़ा सार्वजनिक सम्मान सूची में दिखाई देगा। आपके दस्तावेज़, संपर्क विवरण और पूरी जानकारी कभी नहीं दिखाई जाती।" },
  name_display_label: { en: "How should your names appear?", hi: "आपके नाम कैसे दिखें?" },
  name_first_only: { en: "First names only", hi: "केवल पहला नाम" },
  name_full: { en: "Full names", hi: "पूरे नाम" },
  photo_title: { en: "Celebration photo (optional)", hi: "उत्सव फ़ोटो (वैकल्पिक)" },
  photo_desc: { en: "Add one photo to feature on the gallery. It is shown ONLY while you keep 'Show my photo' switched on.", hi: "गैलरी में दिखाने के लिए एक फ़ोटो जोड़ें। यह केवल तभी दिखाई जाती है जब आप 'मेरी फ़ोटो दिखाएँ' चालू रखते हैं।" },
  upload_photo: { en: "Upload photo", hi: "फ़ोटो अपलोड करें" },
  show_my_photo: { en: "Show my photo", hi: "मेरी फ़ोटो दिखाएँ" },
  // analytics
  analytics: { en: "Analytics", hi: "विश्लेषण" },
  stat_total: { en: "Applications", hi: "आवेदन" },
  stat_verified: { en: "Verified", hi: "सत्यापित" },
  stat_pending: { en: "Pending review", hi: "समीक्षा लंबित" },
  stat_drafts: { en: "Drafts", hi: "प्रारूप" },
  chart_by_status: { en: "Applications by status", hi: "स्थिति अनुसार आवेदन" },
  chart_by_location: { en: "Top locations", hi: "प्रमुख स्थान" },
  chart_groom_age: { en: "Groom age distribution", hi: "वर आयु वितरण" },
  chart_bride_age: { en: "Bride age distribution", hi: "वधू आयु वितरण" },
  chart_over_time: { en: "Submissions over time", hi: "समय के साथ आवेदन" },
};
